import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './SweedhangamPage.css';
import { LoadEvents, OpenPopup } from '../../Actions';
import { Button } from '../../Components';

function mapStateToProps({ app, user, event }) {
    return { app, user, event };
}

const mapDispatchToProps = dispatch => {
    return {
        openPopup: data => {
            dispatch(OpenPopup(data));
        },
        list: () => {
            dispatch(LoadEvents())
        }
    };
};
var months = [{"en":"January", "ta":"ஜனவரி"},{"en":"February", "ta":"பிப்ரவரி"},{"en":"March", "ta":"மார்ச்"},{"en":"April", "ta":"ஏப்ரல்"},{"en":"May", "ta":"மே"},{"en":"June", "ta":"ஜூன்"},{"en":"July", "ta":"ஜூலை"},{"en":"August", "ta":"ஆகஸ்ட்"},{"en":"September", "ta":"செப்டம்பர்"},{"en":"October", "ta":"அக்டோபர்"},{"en":"November", "ta":"நவம்பர்"},{"en":"December", "ta":"டிசம்பர்"}]
class _SweedhangamPage extends Component {
    static propTypes = {
        user: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    };
    constructor(props) {
        super(props);
        this.state = {
            selected: 0,
        }
    }
    componentDidMount() {
        this.props.list();
    }
    goToDetails(id) {
        this.props.history.push("/events/" + id)
    }
    LanguageDate(text){
        if (this.props.app.language === 'ta' ){
            months.forEach(x=>{
                text = text.replace(x.en, x.ta);
            })
        }
        return text;
    }
    getEventList(){
        return this.props.event?.list.filter(x=> this.props.user.role === "Admin" ? true : x.published === true) || [];
    }
    render() {
        return (
            <div className="contact_container">
                <div className='contact_page_header'>
                    <h3>{ months[this.props.match.params.month-1][this.props.app.language === 'ta' ? 'ta':'en'] + " " + this.props.match.params.year }</h3>
                </div>
                {
                    this.props.user.role === "Admin" &&
                    <div className='create_event'>
                        <Button onClick={() => { this.props.history.push("/editevent/new") }}>Create New Event</Button>
                    </div>
                }
                <div className='events'>
                    <div className='events_tab_container'>
                        <embed src={"/api/sweedhangam/" + ("0" + this.props.match.params.month).slice(-2) + "-" + this.props.match.params.year + ".pdf"} type="application/pdf" width="100%" height="600px"></embed>
                    </div>
                </div>
            </div>
        );
    }
}

export const SweedhangamPage = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(_SweedhangamPage)
);